import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { ONBOARDING_CONST } from '@/constant';
import { useTypedSearchParams } from '@/hook';
import { VButton, VFlex, VStack, storage } from '@/package';
import type { OnboardingForm, OnboardingSearchParams } from '@/type';

import Card from './Card';

const Complete = ({ stepEnabled }: { stepEnabled: boolean }) => {
  const { watch } = useFormContext<OnboardingForm>();
  const { set, flush } = useTypedSearchParams<OnboardingSearchParams>();
  const navigate = useNavigate();
  const pickedPlan = watch('tier');

  const { t } = useTranslation();

  const enterpriseTierStr = t('pricing.enterprise.anguillidae');

  const subTitle =
    pickedPlan.plan === enterpriseTierStr
      ? t('pricing.enterpriseUserPrice.trueborn')
      : t('pricing.freetierUserPrice.restowal');

  useEffect(() => {
    if (!stepEnabled) {
      set('step', ONBOARDING_CONST.ONBOARDING_STEP_QUERY_PARAM.TENANT);
      flush();
    } else {
      storage.local.remove(ONBOARDING_CONST.KEYS.STORAGE_ONBOARDING_FORM_DATA);
    }
  }, []);

  return (
    <VFlex direction="col" className="mt-6 gap-6">
      <VFlex direction="col" className="items-center gap-4">
        <div
          className="flex justify-center text-center text-body-xl"
          style={{ whiteSpace: 'pre-line' }}
        >
          {t('onboarding.completeSubTitle.histozoic')}
        </div>
        <Card
          list={pickedPlan.descriptions}
          subTitle={subTitle}
          title={pickedPlan.plan}
          isCompleted
        />

        <VStack className="w-full" gap={0.25} items="center">
          <div
            className="flex justify-center text-center text-body-xl"
            style={{ whiteSpace: 'pre-line' }}
          >
            {t('onboarding.completeSales.becher', { email: watch('email') })}
          </div>
          <div className="text-body-lg">
            {t('onboarding.completeInfoContact.tractile')}
          </div>
        </VStack>
      </VFlex>

      <VFlex className="w-full justify-center">
        <VButton
          className="w-[296px]"
          outlined
          variant="secondary"
          onClick={() => navigate('/landing')}
        >
          {t('onboarding.completeBackMainPage.trypanolysis')}
        </VButton>
      </VFlex>
    </VFlex>
  );
};

export default Complete;
